export default __webpack_public_path__ + "static/media/ThePiano_10.e2572ce6.png";